import React from 'react';
import { ProFormDependency, ProFormSelect } from '@ant-design/pro-form';
import { useQuery, gql } from '@apollo/client';
import { PLACEHOLDER } from 'constants/form';

const GET_FACULTIES_FOR_SELECT_DEPARTMENT = gql`
  query GET_FACULTIES_FOR_SELECT_DEPARTMENT($ids: [ID!], $state: State) {
    faculties(ids: $ids, state: $state) {
      id
      name
      abbreviation
      departments {
        id
        name
        abbreviation
        disabled
      }
    }
  }
`;

const SelectDepartment = ({ ...props }) => {
  const { data, loading } = useQuery(GET_FACULTIES_FOR_SELECT_DEPARTMENT, {
    variables: { state: 'ACTIVE' },
  });

  return (
    <ProFormDependency name={['faculty']}>
      {({ faculty }) => {
        const departments = loading
          ? []
          : faculty
          ? data?.faculties
              .find(({ id }) => id === faculty)
              .departments.filter(({ disabled }) => disabled === false)
          : data?.faculties.reduce((acc, { departments }) => {
              return [
                ...acc,
                ...departments.filter(({ disabled }) => disabled === false),
              ];
            }, []);

        return (
          <ProFormSelect
            showSearch
            label="Department"
            name="department"
            width="xl"
            placeholder={PLACEHOLDER.PLEASE_SELECT}
            valueEnum={departments?.reduce(
              (acc, { id, name, abbreviation }) => {
                acc[id] = `${abbreviation} - ${name}`;
                return acc;
              },
              {}
            )}
            rules={[
              {
                required: true,
                message: 'Please select department!',
              },
            ]}
            {...props}
          />
        );
      }}
    </ProFormDependency>
  );
};

export default SelectDepartment;
